import { render, staticRenderFns } from "./IdentifyUploadFailure.vue?vue&type=template&id=3ae5c085&scoped=true"
import script from "./IdentifyUploadFailure.vue?vue&type=script&lang=js"
export * from "./IdentifyUploadFailure.vue?vue&type=script&lang=js"
import style0 from "./IdentifyUploadFailure.vue?vue&type=style&index=0&id=3ae5c085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae5c085",
  null
  
)

export default component.exports